<template>
    <div class="order-shell">
        <div class="wechat-pay-shell" @click.stop="show_wechat_pay=false;clear_pay_timer()" v-if="show_wechat_pay">
            <div class="wechat-content" @click.stop="">
                <img src="@/assets/colse-icon.png" alt="" class="colse-btn"
                     @click.stop="show_wechat_pay=false;clear_pay_timer()">
                <div class="pay-tips">扫一扫付款 (元)</div>
                <div class="pay-price">
                    ￥{{pay_money}}
                </div>
                <div class="pay-qrcode" @click.stop="show_wechat_pay=false">
                    <div id="qrcode2" ref="qrcode" style="width: 100%;height: 100%;"></div>
                </div>
                <div class="pay-type">
                    <img src="@/assets/weixin.png" alt="" class="wechat-pay-icon">
                    微信支付
                </div>
            </div>
        </div>
        <div class="box">
            <el-tabs v-model="activeName" class="tab">
                <el-tab-pane label="待付款" name="first">
                    <div class="order-list-shell" v-show="order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">状态</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <NoData v-if="order_list.length<1" width="168px" height="235px" :icon="no_icon"></NoData>
                            <div class="mass-box" v-for="(item,index) in order_list" :key="index">
                                <div class="order-no-time">
                                    <div class="order-no">订单编号：{{item.order_num}}</div>
                                    <div class="order-time">下单时间：{{item.add_time}}</div>
                                    <div class="select-box" @click="select_manage(item,index)" v-if="order_status==4">
                                        <img src="@/assets/icon_check.png" alt="" v-show="item.is_select">
                                    </div>
                                </div>
                                <div class="mass-content" @click="order_detail(item,index)">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="item.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{item.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{item.course_type}}</div>
                                            <div class="info-num">
                                                学时：{{item.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{item.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="tips">
                                            <div class="status" v-if="activeName=='first'">待付款</div>
                                        </div>
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn cancel" @click.stop="calcel_order(item,index)">取消订单</div>
                                            <div class="btn"
                                                 @click.stop="order_pay(item,index)">立即支付
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="paging-shell">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="page"
                                    :page-size="pageSize"
                                    background layout="prev, pager, next" :total="total"></el-pagination>
                        </div>
                    </div>
                    <div class="order-detail-shell" v-show="!order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <div class="mass-box" @click="order_detail(order_info)">
                                <div class="mass-content">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="order_info.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{order_info.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{order_info.course_type}}</div>
                                            <div class="info-num">
                                                学时：{{order_info.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{order_info.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn cancel" @click.stop="look_course(order_info)">查看课程
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">订单信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            订单编号: {{order_info.order_num}}
                                        </div>
                                        <div class="info-box">
                                            订单状态: {{order_info.order_status}}
                                        </div>
                                        <div class="info-box">
                                            下单时间: {{order_info.add_time}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">支付信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            课程金额: {{order_info.order_info.course_price}}
                                        </div>
                                        <div class="info-box">
                                            优惠劵抵扣: {{order_info.discount_money}}
                                        </div>
                                        <div class="order-pay-price">
                                            应付金额：￥ {{order_info.pay_money}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-btn-shell">
                                    <div class="cancel-btn" @click.stop="order_detail_show = true">返回上一级</div>

                                    <div class="cancel-btn" @click.stop="calcel_order(order_info)"
                                         v-if="activeName=='first'">
                                        取消订单
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='first'" @click.stop="order_pay(order_info)">
                                        立即支付
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='second' || activeName=='manage'">开始学习</div>
                                    <div class="pay-btn" v-if="activeName=='third'">核销码</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已付款" name="second">
                    <div class="order-list-shell" v-show="order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">状态</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <NoData v-if="order_list.length<1" width="168px" height="235px" :icon="no_icon"></NoData>
                            <div class="mass-box" v-for="(item,index) in order_list" :key="index">
                                <div class="order-no-time">
                                    <div class="order-no">订单编号：{{item.order_num}}</div>
                                    <div class="order-time">下单时间：{{item.add_time}}</div>
                                    <div class="select-box" @click="select_manage(item,index)" v-if="order_status==4">
                                        <img src="@/assets/icon_check.png" alt="" v-show="item.is_select">
                                    </div>
                                </div>
                                <div class="mass-content" @click="order_detail(item,index)">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="item.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{item.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{item.course_type}}</div>
                                            <div class="info-num">
                                                学时：{{item.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{item.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="tips">
                                            <div class="status" v-if="activeName=='second'">已付款</div>
                                        </div>
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn" v-if="activeName=='second'"
                                                 @click.stop="start_study(item,index)">开始学习
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="paging-shell">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="page"
                                    :page-size="pageSize"
                                    background layout="prev, pager, next" :total="total"></el-pagination>
                        </div>
                    </div>
                    <div class="order-detail-shell" v-show="!order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <div class="mass-box" @click="order_detail(order_info)">
                                <div class="mass-content">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="order_info.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{order_info.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{order_info.course_type}}</div>
                                            <div class="info-num">
                                                学时：{{order_info.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{order_info.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn cancel" @click.stop="look_course(order_info)">查看课程
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">订单信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            订单编号: {{order_info.order_num}}
                                        </div>
                                        <div class="info-box">
                                            订单状态: {{order_info.order_status}}
                                        </div>
                                        <div class="info-box">
                                            下单时间: {{order_info.add_time}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">支付信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            课程金额: {{order_info.order_info.course_price}}
                                        </div>
                                        <div class="info-box">
                                            优惠劵抵扣: {{order_info.discount_money}}
                                        </div>
                                        <div class="order-pay-price">
                                            应付金额：￥ {{order_info.pay_money}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-btn-shell">
                                    <div class="cancel-btn" @click.stop="order_detail_show = true">返回上一级</div>
                                    <div class="cancel-btn" @click.stop="calcel_order(order_info)"
                                         v-if="activeName=='first'">
                                        取消订单
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='first'" @click.stop="order_pay(order_info)">
                                        立即支付
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='second' || activeName=='manage'"
                                         @click.stop="start_study(item,index)">开始学习
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='third'">核销码</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="可核销" name="third">
                    <div class="order-list-shell" v-show="order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">状态</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <NoData v-if="order_list.length<1" width="168px" height="235px" :icon="no_icon"></NoData>
                            <div class="mass-box" v-for="(item,index) in order_list" :key="index">
                                <div class="order-no-time">
                                    <div class="order-no">订单编号：{{item.order_num}}</div>
                                    <div class="order-time">下单时间：{{item.add_time}}</div>
                                    <div class="select-box" @click="select_manage(item,index)" v-if="order_status==4">
                                        <img src="@/assets/icon_check.png" alt="" v-show="item.is_select">
                                    </div>
                                </div>
                                <div class="mass-content" @click="order_detail(item,index)">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="item.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{item.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{item.course_type}}训</div>
                                            <div class="info-num">
                                                学时：{{item.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{item.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="tips">
                                            <div class="status" v-if="activeName=='third'">可核销</div>
                                        </div>
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn" v-if="activeName=='third'">核销码</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="paging-shell">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="page"
                                    :page-size="pageSize"
                                    background layout="prev, pager, next" :total="total"></el-pagination>
                        </div>
                    </div>
                    <div class="order-detail-shell" v-show="!order_detail_show">
                        <div class="mass-header">
                            <div class="mass-info">课程信息</div>
                            <div class="mass-price">订单金额</div>
                            <div class="mass-status">操作</div>
                        </div>
                        <div class="list-shell">
                            <div class="mass-box" @click="order_detail(order_info)">
                                <div class="mass-content">
                                    <div class="mass-info">
                                        <div class="mass-img">
                                            <img :src="order_info.order_info.course_img" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="info-name">{{order_info.order_info.course_name}}</div>
                                            <div class="info-type">类别：{{order_info.course_type}}</div>
                                            <div class="info-num">
                                                学时：{{order_info.order_info.cnt_course}}课时
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mass-price">
                                        ￥{{order_info.pay_money}}
                                    </div>
                                    <div class="mass-status">
                                        <div class="btn-list">
                                            <div class="btn cancel" @click.stop="look_course(order_info)">查看课程
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">订单信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            订单编号: {{order_info.order_num}}
                                        </div>
                                        <div class="info-box">
                                            订单状态: {{order_info.order_status}}
                                        </div>
                                        <div class="info-box">
                                            下单时间: {{order_info.add_time}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">支付信息</div>
                                    <div class="info-shell">
                                        <div class="info-box">
                                            课程金额: {{order_info.order_info.course_price}}
                                        </div>
                                        <div class="info-box">
                                            优惠劵抵扣: {{order_info.discount_money}}
                                        </div>
                                        <div class="order-pay-price">
                                            应付金额：￥ {{order_info.pay_money}}
                                        </div>
                                    </div>
                                </div>
                                <div class="order-info">
                                    <div class="title">核销码</div>
                                    <div class="info-shell" style="height: 234px;align-items: center;">
                                        <div class="order-qrcode">
                                            <div id="qrcode" ref="qrcode" style="width:100%;height: 100%;"></div>
                                        </div>
                                        <div class="qrcode-tips">
                                            <!-- <p>该课程共10课时， </p> -->
                                            <p>核销码可重复使用</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-btn-shell">
                                    <div class="cancel-btn" @click.stop="order_detail_show = true">返回上一级</div>
                                    <div class="cancel-btn" @click.stop="calcel_order(order_info)"
                                         v-if="activeName=='first'">
                                        取消订单
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='first'" @click.stop="order_pay(order_info)">
                                        立即支付
                                    </div>
                                    <div class="pay-btn" v-if="activeName=='second' || activeName=='manage'">开始学习</div>
                                    <div class="pay-btn" v-if="activeName=='third'">核销码</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="handle-manage" :class="{'handle-manage-active': bill_manage}" v-show="order_status==4"
                 @click.stop="bill_manage=!bill_manage">批量开发票
            </div>
        </div>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'
  import { formatTime } from '../../../utils'
  import QRCode from 'qrcodejs2'

  export default {
    components: {
      NoData
    },
    data () {
      return {
        pay_money: '0.0',
        show_wechat_pay: false,
        pay_timer: null,
        order_status_list: [
          '待付款',
          '已支付',
          '可核销',
          '可开发票'
        ],
        bill_manage: false,
        order_ids: [],
        identifier: '',
        company_name: '',
        user_tel: '',
        user_email: '',
        user_name: '',
        invoice_type: 1,	// 开票类型（0.企业、单位 1.个人）
        bill_show: false,
        order_detail_show: true,
        order_status: 1, // 0 全部 1 '待付款', 2 '已支付', 3'可核销', 4'已
        activeName: 'first',
        // 订单管理
        no_icon: require('@/assets/no-order.png'),
        order_list: [],
        total: 0,
        page: 1,
        pageSize: 3,
        order_info: {
          order_info: {
            course_img: ''
          }
        },
        user_info: this.$store.state.user_info
      }
    },
    mounted () {
      this.get_order_list()
      this.user_name = this.user_info.nick_name
    },
    beforeDestroy () {
      window.clearInterval(this.pay_timer)
    },
    methods: {
      start_study (item, index) {
        this.$router.push('/Gostudy?course_id=' + item.order_info.course_id)
      },
      make_pay (linkUrl) {
        this.$refs.qrcode.innerHTML = '' // 防止重复生成
        let qrcode = new QRCode('qrcode2', {
          width: 160,
          height: 160,
          text: linkUrl,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
        console.log(qrcode)
      },
      make (linkUrl) {
        this.$refs.qrcode.innerHTML = '' // 防止重复生成
        let qrcode = new QRCode('qrcode', {
          width: 160,
          height: 160,
          text: linkUrl,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
        console.log(qrcode._el.title)
      },
      go_bill (item, index) {
        this.bill_show = true
        this.order_ids = []
        if (item) { // 单个发票
          this.order_ids.push(item.order_id)
        } else {
        }
      },
      open_bill () { // 开发票
        if (this.order_ids.length < 1) {
          for (let i = 0; i < this.order_list.length; i++) {
            if (this.order_list[i].is_select) {
              this.order_ids.push(this.order_list[i].order_id)
            }
          }
        }
        if (this.invoice_type === 0 && !this.company_name) {
          return this.API.SMessage('请输入营业执照上公司/单位全称')
        }
        if (!this.user_tel) {
          return this.API.SMessage('请输入手机号码')
        }
        if (!this.user_email) {
          return this.API.SMessage('请输入邮箱号码')
        }
        // if (!this.identifier) {
        //   return this.API.SMessage('请输入纳税人识别号')
        // }

        this.API.post('user/user_infos-give_bill', {
          order_id: this.order_ids.join(','),
          invoice_type: this.invoice_type,
          identifier: this.identifier || '',
          company_name: this.company_name,
          user_tel: this.user_tel,
          user_email: this.user_email,
          user_name: this.user_name
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.API.SMessage(res.message)
          this.invoice_type = ''
          this.identifier = ''
          this.company_name = ''
          this.user_tel = ''
          this.user_email = ''
          this.user_name = ''
        })
      },
      fromTime (time) {
        return formatTime(time)
      },
      handleClick (row) {
        // console.log(row);
      },
      // 订单列表
      get_order_list () { // 0 全部 1 '待付款', 2 '已支付', 3'可核销', 4'已
        this.API.post('user/user_infos-order_list', {
          order_status: this.order_status,
          page_size: this.pageSize,
          page: this.page
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.total = res.data.cont_order
          for (let i = 0; i < res.data.order_list.length; i++) {
            res.data.order_list[i].is_select = false
          }
          this.order_list = res.data.order_list
        })
      },
      select_manage (item, index) {
        this.order_list[index].is_select = !this.order_list[index].is_select
      },
      handleSizeChange (val) { // 每页条数操作
        this.page = 1
        this.get_order_list()
      },
      handleCurrentChange (val) { // 页数操作
        this.page = val
        this.get_order_list()
      },
      look_course (item) { // 查看课程
        this.$router.push('/Coursetobuy?course_id=' + item.order_info.course_id)
      },
      calcel_order (item, index) { // 取消订单
        this.API.post('user/user_infos-cancel_order', {
          order_id: item.order_id
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.API.SMessage(res.message)
          this.order_detail_show = true
          this.get_order_list()
        })
      },
      order_pay (item, index) { // 订单支付
        this.API.post('user/user_infos-pay_order', {
          order_id: item.order_id,
          pay_way: 2,
          is_h5: 2
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.show_wechat_pay = true
          this.pay_money = res.data.pay_money
          setTimeout(() => {
            this.make_pay(res.data.pay_info.pay_info.code_url)
            this.pay_timer = setInterval(() => {
              this.get_order_detail(item.order_id)
            }, 1000)
          }, 100)
        })
      },
      clear_pay_timer () {
        window.clearInterval(this.pay_timer)
      },
      get_order_detail (order_id) {
        this.API.post('user/user_infos-order_detail', {
          order_id: order_id,
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          if (res.data.order_info.order_status != '待付款') {
            this.$message({
              showClose: true,
              message: '购买成功',
              type: 'success',
            })
            this.show_wechat_pay = false
            window.clearInterval(this.pay_timer)
            this.page = 1
            this.get_order_list()
          }
        })
      },
      order_detail (item) { // 订单详情
        this.order_detail_show = !this.order_detail_show
        this.API.post('user/user_infos-order_detail', {
          order_id: item.order_id
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.make(res.data.order_info.order_num)
          this.order_info = res.data.order_info
        })
      }
    },
    watch: {
      activeName: function () {
        let _this = this
        this.page = 1
        this.order_detail_show = true
        switch (this.activeName) {
          case 'first':
            this.order_status = 1
            break
          case 'second':
            this.order_status = 2
            break
          case 'third':
            this.order_status = 3
            break
          case 'manage':
            this.order_status = 4
            break
        }
        this.get_order_list()
      }
    }
  }
</script>

<style lang="less" scoped>
    .wechat-pay-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;

        .wechat-content {
            position: relative;
            width: 710px;
            height: 592px;
            background-color: #fff;
            padding: 60px;

            .colse-btn {
                position: absolute;
                top: 20px;
                right: 20px;
                width: 24px;
                height: 24px;
            }

            .pay-tips {
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                text-align: center;
            }

            .pay-price {
                font-size: 40px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #D8251C;
                text-align: center;
                margin-top: 10px;
            }

            .pay-qrcode {
                width: 252px;
                height: 252px;
                border: 1px solid #eee;
                margin: 20px auto;
            }

            .pay-type {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;

                .wechat-pay-icon {
                    width: 34px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
        }
    }

    .bill-shell {
        .bill-header {
            width: 920px;
            height: 100px;
            padding: 20px;
            background: #F8F8F8;
            border: 1px solid #E5E5E5;

            .tips {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 600;
                color: red;
                margin-bottom: 15px;
            }

            .wran {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FD0000;
            }
        }

        .bill-box {
            display: flex;
            align-items: center;
            height: 80px;
        }

        .bill-name {
            width: 130px;
        }

        .plac::placeholder {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #CCCCCC;

        }

        .bill-input {
            display: flex;

            input {
                width: 402px;
                height: 46px;
                border: 1px solid #D2D2D2;
                padding-left: 10px;
            }

            .select-box {
                display: flex;
                align-items: center;
                margin-right: 20px;

                .select {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    border: 1px solid #c9c9c9;
                    margin-right: 10px;
                }
            }
        }

        .submit-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 30px;
            width: 380px;
            height: 56px;
            background: #18949C;
            border-radius: 5px;
            margin: 20px auto;
        }
    }

    .list-shell {
        min-height: 50vh;
    }

    .go-bill-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 380px;
        height: 56px;
        background: #18949C;
        border-radius: 10px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin: 10px auto;
    }

    .box {
        width: 960px;
        background: #ffffff;
        position: relative;

        .tab {
            margin: 20px;
        }

        .handle-manage {
            position: absolute;
            top: 30px;
            right: 30px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
        }

        .handle-manage-active {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #2BAAB5;
        }
    }

    .mass-header {
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        height: 60px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;;

        .mass-info, .mass-price, .mass-status {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .mass-info {
            width: 50%;
        }

        .mass-price, .mass-status {
            width: 20%;
        }
    }

    .btn-list {
        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            width: 100px;
            height: 40px;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            background-color: rgba(42, 169, 181, 1);
        }

        .cancel {
            color: rgba(43, 170, 181, 1);
            margin-bottom: 10px;
            border: 1px solid #2AA9B5;
            background-color: #fff;
        }
    }

    .mass-box {

        .mass-info {
            width: 50%;
        }

        .mass-price, .mass-status {
            width: 20%;
        }

        .mass-content {
            display: flex;
            height: 170px;
            background-color: #fff;

            .mass-price, .mass-status {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
            }

            .mass-info {
                display: flex;
                align-items: center;
                padding: 0 10px;

                .mass-img {
                    width: 183px;
                    min-width: 183px;
                    height: 110px;
                    margin-right: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }


                .info-name {
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #000000;
                    display: -webkit-box;
                    width: 200px;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    white-space:nowrap;
                    -o-text-overflow: ellipsis; /* for Opera */
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .info-type, .info-num {
                    width: 100%;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #999999;
                    margin-top: 5px;
                }
            }

            .info {
                display: flex;
                flex-wrap: wrap;
            }

            .mass-price {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #EB2020;
            }

            .mass-status {
                align-items: center;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #2AA9B5;

                .status {
                    width: 100%;
                    text-align: center;
                }
            }

            .warn {
                color: red;
            }

        }

        .order-info {
            .title {
                display: flex;
                align-items: center;
                padding-left: 20px;
                height: 50px;
                background: #F8F8F8;
                border: 1px solid #E5E5E5;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
            }

            .info-shell {
                display: flex;
                flex-wrap: wrap;
                height: 134px;
                background-color: #fff;
                border: 1px solid #eee;
                margin-bottom: 15px;
                padding-left: 20px;

                .info-box {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 30%;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666666;
                }

                .order-pay-price {
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #EA3C46;
                }

                .order-qrcode {
                    width: 168px;
                    min-width: 168px;
                    height: 168px;
                    margin-right: 20px;
                }

                .qrcode-tips {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    width: 166px;
                    height: 100%;
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666666;
                    padding: 70px 0;

                    p {
                        display: flex;
                        width: 100%;
                    }
                }
            }

        }

        .order-btn-shell {
            display: flex;
            align-items: center;
            justify-content: center;

            .cancel-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100px;
                height: 40px;
                margin: 0 10px;
                border: 1px solid #2AA9B5;
                border-radius: 5px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #2AA9B5;
            }

            .pay-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100px;
                height: 40px;
                background: #2AA9B5;
                border-radius: 5px;
                margin: 0 10px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
        }
    }

    .order-no-time {
        display: flex;
        align-items: center;
        height: 50px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        background-color: #f8f8f8;
        margin-top: 10px;
        padding: 0 10px;
        position: relative;

        .order-time {
            margin-left: 30px;
        }

        .select-box {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 1px solid #aaaaaa;
            position: absolute;
            right: 20px;
        }
    }

    .invoice-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 112px;

        .invoice-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 380px;
            height: 56px;
            background: #18949C;
            border-radius: 10px;
            color: #fff;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }
    }
</style>
